<template>
  <div class="users-list">
    <b-table hover :items="users" :fields="fields">
      <template slot="lastname" slot-scope="data">
        {{data.item.lastname}}
      </template>
      <template slot="firstname" slot-scope="data">
        {{data.item.firstname}}
      </template>
      <template slot="ffb" slot-scope="data">
        {{data.item.ffb}}
      </template>
      <template slot="blame" slot-scope="data">
        {{data.item.blame}}
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios';
import store from 'store';
import UpdateService from '../services/update-operations.js';
const updateService = new UpdateService();
export default {
  name: 'usersList',
  data: () => ({
    users: [],
    fields: [
      {
        key: 'lastname',
        label: 'Nom',
        sortable: true
      },
      {
        key: 'firstname',
        label: 'Prenom',
        sortable: true
      },
      {
        key: 'ffb',
        label: 'Bons Fast Food disponible(s)',
        sortable: true
      },
      {
        key: 'blame',
        label: 'Avertissement(s)',
        sortable: true
      }
    ]
  }),
  mounted() {
    updateService.getUsers().then(res => (this.users = res));
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.button-remove {
  margin-right: 10px;
}
.button-add {
  margin-left: 10px;
}
.login-btn {
  margin: 1%;
}
</style>
